export default __webpack_public_path__ + "c97a19c0516d21ae71d3a781b7b1bb25.svg";